// Reglas de formato compartidas por los pasos del checkout.

// Mismo criterio que NBAPI (CheckOutController.MailValido): admite "+" y "%" en la parte local
// (ej. nombre+uai@gmail.com), que la regla vieja del front rechazaba.
export const EMAIL_VALIDO = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const esEmailValido = (valor) => EMAIL_VALIDO.test((valor || '').trim());

// DNI de 7 u 8 dígitos: los documentos menores a 10.000.000 tienen 7. SIGUE acepta hasta 9 sin mínimo
// (pweb_updateW) y NBAPI busca al usuario reconocido por coincidencia exacta, así que 7 dígitos no
// matchea con otra persona. Mismo criterio que ya usaba Facturación.
export const DNI_VALIDO = /^\d{7,8}$/;

export const esDniValido = (valor) => DNI_VALIDO.test(valor || '');
